import { Container, Footer } from './styled'

import React from 'react'

interface ModalFooterProps {
  justify?: string
  background?: string
  children?: React.ReactNode
}

export const ModalFooter = ({
  justify = 'flex-end',
  background,
  children,
}: ModalFooterProps) => {
  return (
    <Container>
      <Footer justify={justify} background={background}>
        {children}
      </Footer>
    </Container>
  )
}
